module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAMAAADX9CSSAAAAPFBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAABHcEwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABzsPWDAAAAFHRSTlNFBiMIA0AfABk5PRsuJwoMNDEYKSnO2ccAAACpSURBVCjPbZBXEsQgDENFNaYmm/vfdcNQQopm+HnyCFugqiI3YzaZaQrn0xFdaeXZg50iUsGD1eTaQ46pBNaDxwsTHSMKGUyLDFoSJNzKLWzjDLHyjNi4wYpJ9Ngn14M/cgr2z38lQuMK/r6n6HcdOC4c+3jtgZH68bXA3+xNMLwtQhRpAMBdPafRs3XDaNtnuzPvQREN434VTePFu/Hmzfjg1TBfnIK3f2jeDT/9Dif1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/serachicon.png
// module id = n6/2
// module chunks = 18